import { useMap } from '@vis.gl/react-google-maps';
import React from 'react';

export const MapViewLevelController: React.FC<{
	viewport: google.maps.LatLngBounds | null;
}> = ({ viewport }) => {
	const map = useMap();
	React.useEffect(() => {
		if (!map) return;
		if (viewport) {
			map.fitBounds(viewport);
		}
	}, [map, viewport]);
	return null;
};
